import css from "standard/css";

const style = css`
  :root {
    --spacing-quarck: 4px;
    --spacing-nano: 8px;
    --spacing-xxxs: 16px;
    --spacing-xxs: 24px;
    --spacing-xs: 32px;
    --spacing-sm: 40px;
    --spacing-md: 48px;
    --spacing-lg: 56px;
    --spacing-xl: 64px;
    --spacing-xxl: 80px;
    --spacing-xxxl: 120px;
    --spacing-huge: 160px;
    --spacing-giant: 200px;
    --spacing_inset-quarck: 4px;
    --spacing_inset-nano: 8px;
    --spacing_inset-xs: 16px;
    --spacing_inset-sm: 24px;
    --spacing_inset-md: 32px;
    --spacing_inset-lg: 40px;
    --spacing_inset-huge: 48px;
    --spacing_inset-giant: 56px;
  }
`;

export default style;
